const sliderInit = (isUpdate) => {
	if (
		document.querySelectorAll('.js-media-list, .js-media-list-mobile') &&
		document.querySelectorAll('.js-media-list, .js-media-list-mobile').length > 0
	) {
		document.querySelectorAll('.js-media-list, .js-media-list-mobile').forEach((elem, index) => {
			if (!elem.querySelector('.swiper-slide')) return
			let prevButton = elem.querySelector('.product__slider-nav .swiper-button-prev')
			let nextButton = elem.querySelector('.product__slider-nav .swiper-button-next')
			let pagination = elem.querySelector('.product__pagination')
			const initialSlide = elem.dataset.currentIndex || 0

			if (elem.swiper) {
				elem.swiper.destroy(true, true)
			}

			let slider = new Swiper(elem, {
				initialSlide: initialSlide,
				slidesPerView:
					elem
						.closest('.product__outer')
						.classList.contains('product__gallery--full_screen_top-mobile') ||
					elem
						.closest('.product__outer')
						.classList.contains('product__gallery--single_aside-mobile') ||
					elem
						.closest('.product__outer')
						.classList.contains('product__gallery--thumbs_aside-mobile')
						? 1
						: 1.1,
				spaceBetween: elem
					.closest('.product__outer')
					.classList.contains('product__gallery--multiple_top-mobile')
					? 0
					: 1,
				autoHeight: true,
				speed: 500,
				freeMode: {
					enabled:
						window.innerWidth < 750
							? elem
									.closest('.product__outer')
									.classList.contains('product__gallery--multiple_top-mobile')
							: elem.closest('.product__outer').classList.contains('product__outer--multiple-top'),
					sticky: true,
				},
				navigation: {
					nextEl: nextButton,
					prevEl: prevButton,
				},
				pagination: {
					el: pagination,
					type: 'bullets',
					clickable: true,
				},
				thumbs: {
					swiper: elem.nextElementSibling.querySelector('.js-media-sublist')?.swiper
						? elem.nextElementSibling.querySelector('.js-media-sublist').swiper
						: '',
				},
				breakpoints: {
					750: {
						slidesPerView:
							elem.closest('.product__outer').classList.contains('product__outer--full-screen') ||
							elem.closest('.product__outer').classList.contains('product__outer--single-aside') ||
							elem.closest('.product__outer').classList.contains('product__outer--thumbs-aside')
								? 1
								: 1.1,
						spaceBetween: elem
							.closest('.product__outer')
							.classList.contains('product__outer--multiple-top')
							? 0
							: 1,
					},
					// Fixed
					990: {
						slidesPerView:
							elem.closest('.product__outer').classList.contains('product__outer--full-screen') ||
							elem.closest('.product__outer').classList.contains('product__outer--single-aside') ||
							elem.closest('.product__outer').classList.contains('product__outer--thumbs-aside')
								? 1
								: 2.37,
					},
				},
				on: {
					afterInit: function (swiper) {
						if (
							(document.querySelector('.product__outer--multiple-top') &&
								window.innerWidth >= 750) ||
							(document.querySelector('.product__gallery--multiple_top-mobile') &&
								window.innerWidth < 750)
						) {
							document.querySelectorAll('.product__media-toggle').forEach((elem, index) => {
								elem.addEventListener('click', (e) => {
									var target = e.currentTarget

									if (
										document.querySelector('.js-popup-slider') &&
										document.querySelector('.js-popup-slider').swiper
									) {
										document.querySelector('.js-popup-slider').swiper.slideTo(index)
									}
								})
							})
						}
					},
					slideChangeTransitionStart: function () {
						const slider =
							document.querySelector('.js-media-list') ||
							document.querySelector('.js-media-list-mobile')
						if (
							document.querySelector('.js-media-sublist') &&
							document.querySelector('.js-media-sublist').swiper
						) {
							document.querySelector('.js-media-sublist').swiper.slideTo(slider.swiper.activeIndex)
						}
					},
					slideChange: function () {
						window.pauseAllMedia()
						this.params.noSwiping = false

						if (
							document.querySelector('.js-popup-slider') &&
							document.querySelector('.js-popup-slider').swiper &&
							!(
								(document.querySelector('.product__outer--multiple-top') &&
									window.innerWidth >= 750) ||
								(document.querySelector('.product__gallery--multiple_top-mobile') &&
									window.innerWidth < 750)
							)
						) {
							document.querySelector('.js-popup-slider').swiper.slideTo(this.activeIndex)
						}
					},
					slideChangeTransitionEnd: function () {
						if (this.slides[this.activeIndex].querySelector('model-viewer')) {
							this.slides[this.activeIndex]
								.querySelector('.shopify-model-viewer-ui__button--poster')
								.removeAttribute('hidden')
						}
					},
					touchStart: function () {
						if (this.slides[this.activeIndex].querySelector('model-viewer')) {
							if (
								!this.slides[this.activeIndex]
									.querySelector('model-viewer')
									.classList.contains('shopify-model-viewer-ui__disabled')
							) {
								this.params.noSwiping = true
								this.params.noSwipingClass = 'swiper-slide'
							} else {
								this.params.noSwiping = false
							}
						}
					},
				},
			})

			if (isUpdate) {
				setTimeout(function () {
					slider.update()
				}, 800)
			}
		})

		const pageResizeObserve = new ResizeObserver((entries) => {
			const [entry] = entries

			if (entry.contentRect.width < 750) {
				const slider = entry.target.querySelector('.js-media-list')
				const sliderMobile = entry.target.querySelector('.js-media-list-mobile')

				if (
					slider &&
					slider.swiper &&
					(entry.target.querySelector('.product__gallery--static_multicolumns_aside-mobile') ||
						entry.target.querySelector('.product__gallery--static_column_aside-mobile'))
				) {
					slider.swiper.destroy(true, true)
				}

				if (sliderMobile && !slider) {
					if (!sliderMobile.swiper) {
						subSliderInit(true)
						sliderInit(true)
						popupSliderInit(true)
					}
				}
			} else {
				const slider = entry.target.querySelector('.js-media-list')
				const sliderMobile = entry.target.querySelector('.js-media-list-mobile')

				if (sliderMobile && sliderMobile.swiper && !slider) {
					sliderMobile.swiper.destroy(true, true)
				}

				if (slider) {
					if (!slider.swiper) {
						subSliderInit(true)
						sliderInit(true)
						popupSliderInit(true)
					}
				}
			}
		})

		if (document.querySelector('.product-section'))
			pageResizeObserve.observe(document.querySelector('.product-section'))
	}
}

const subSliderInit = (isUpdate) => {
	if (
		document.querySelectorAll('.js-media-sublist') &&
		document.querySelectorAll('.js-media-sublist').length > 0
	) {
		document.querySelectorAll('.js-media-sublist').forEach((elem, index) => {
			if (!elem.querySelector('.swiper-slide')) return
			if (elem.swiper) elem.swiper.destroy()
			const isThumbsAside = elem.classList.contains('sublist-thumbs-aside')

			const breakpoint = isThumbsAside ? 1100 : 990

			let subSlider = new Swiper(elem, {
				slidesPerView: 4,
				spaceBetween: 8,
				direction: 'horizontal',
				direction: 'horizontal',
				freeMode: false,
				watchSlidesProgress: true,
				watchSlidesVisibility: true,
				autoHeight: true,
				on: {
					afterInit: function () {
						//this.params.slidesPerView = this.slides.length === 2 ? 2 : 3;
					},
					touchEnd: function (s, e) {
						let range = 5
						let diff = (s.touches.diff = s.isHorizontal()
							? s.touches.currentX - s.touches.startX
							: s.touches.currentY - s.touches.startY)
						if (diff < range || diff > -range) s.allowClick = true
					},
				},
				//transitionStart: function () {
				//	document
				//		.querySelector(".js-media-list")
				//		.swiper.slideTo(
				//			document.querySelector(".js-media-sublist").swiper.activeIndex,
				//		);
				//},
				breakpoints: {
					[breakpoint]: {
						spaceBetween: 4,
						direction: 'vertical',
						slidesPerView: 'auto',
						direction: 'vertical',
						slidesPerView: 'auto',
					},
				},
			})

			const sliderResizeObserve = new ResizeObserver((entries) => {
				const [entry] = entries
				// Fixed
				if (entry.contentRect.width >= breakpoint) {
					setTimeout(() => {
						const sliders = document.querySelectorAll('.js-media-list, .js-media-list-mobile')
						const thumbs = document.querySelectorAll('.product__media-sublist')

						const sliderHeight = sliders[index].getBoundingClientRect().height
						thumbs[index].style.height = `${sliderHeight - 1}px`
					}, 400)
				}
			})

			if (document.querySelector('.product-section'))
				sliderResizeObserve.observe(document.querySelector('.product-section'))
			if (document.querySelector('.product-section'))
				sliderResizeObserve.observe(document.querySelector('.product-section'))

			document.querySelectorAll('.featured-product-section').forEach((section) => {
				sliderResizeObserve.observe(section)
			})

			if (isUpdate) {
				setTimeout(function () {
					subSlider.update()
				}, 800)
			}
		})
	}
}

const popupSliderInit = (isUpdate) => {
	if (document.querySelector('.js-popup-slider .swiper-slide')) {
		let popupSlider = new Swiper(document.querySelector('.js-popup-slider'), {
			slidesPerView: 1,
			navigation: {
				nextEl: '.product-media-modal .product__slider-nav .swiper-button-next',
				prevEl: '.product-media-modal .product__slider-nav .swiper-button-prev',
			},
			pagination: {
				el: '.product-media-modal .product__pagination',
				type: 'bullets',
				clickable: true,
			},
			on: {
				afterInit: function () {
					if (
						document.querySelector('.product__outer--static-multicolumns-aside') ||
						document.querySelector('.product__outer--static-column-aside') ||
						document.querySelector('.product__gallery--static_multicolumns_aside-mobile') ||
						document.querySelector('.product__gallery--static_column_aside-mobile')
					) {
						document
							.querySelectorAll('.product__media-list .product__media-toggle')
							.forEach((elem, index) => {
								elem.addEventListener('click', (e) => {
									if (
										document.querySelector('.js-popup-slider') &&
										document.querySelector('.js-popup-slider').swiper
									) {
										document.querySelector('.js-popup-slider').swiper.slideTo(index)
									}
								})
							})
					}
				},
				slideChange: function () {
					window.pauseAllMedia()
					this.params.noSwiping = false
					document.querySelector('.product-media-modal__content').classList.remove('zoom')
				},
				touchMove: function () {
					document.querySelector('.product-media-modal__content').classList.remove('zoom')
				},
				slideChangeTransitionEnd: function () {
					if (this.slides[this.activeIndex].querySelector('model-viewer')) {
						this.slides[this.activeIndex]
							.querySelector('.shopify-model-viewer-ui__button--poster')
							.removeAttribute('hidden')
					}
				},
				touchStart: function () {
					if (this.slides[this.activeIndex].querySelector('model-viewer')) {
						if (
							!this.slides[this.activeIndex]
								.querySelector('model-viewer')
								.classList.contains('shopify-model-viewer-ui__disabled')
						) {
							this.params.noSwiping = true
							this.params.noSwipingClass = 'swiper-slide'
						} else {
							this.params.noSwiping = false
						}
					}
				},
			},
		})

		if (isUpdate) {
			setTimeout(function () {
				popupSlider.update()
			}, 800)
		}
	}
}

if (navigator.userAgent.indexOf('iPhone') > -1) {
	document
		.querySelector('[name=viewport]')
		.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1')
}

function getFocusableElements(container) {
	return Array.from(
		container.querySelectorAll(
			"summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
		),
	)
}

;(function () {
	const headerDrawer = document.querySelector('header-drawer')
	if (!headerDrawer) return

	const drawerTabs = document.querySelectorAll('.mega-menu__tab')
	if (!drawerTabs) return

	drawerTabs.forEach((tab) => {
		tab.addEventListener('click', () => {
			tab.classList.toggle('tab--active')
			const tabToggler = tab.querySelector('.mega-menu__tab-toggler')
			const initialExpanded = JSON.parse(tabToggler.getAttribute('aria-expanded'))
			tabToggler.setAttribute('aria-expanded', `${!initialExpanded}`)
		})
	})
})()

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
	summary.setAttribute('role', 'button')
	summary.setAttribute('aria-expanded', 'false')

	if (summary.nextElementSibling.getAttribute('id')) {
		summary.setAttribute('aria-controls', summary.nextElementSibling.id)
	}

	summary.addEventListener('click', (event) => {
		event.currentTarget.setAttribute(
			'aria-expanded',
			!event.currentTarget.closest('details').hasAttribute('open'),
		)
	})

	if (summary.closest('header-drawer')) return
	summary.parentElement.addEventListener('keyup', onKeyUpEscape)
})

function onKeyUpEscape(event) {
	if (event.code.toUpperCase() !== 'ESCAPE') return

	const openDetailsElement = event.target.closest('details[open]')
	if (!openDetailsElement) return

	const summaryElement = openDetailsElement.querySelector('summary')
	openDetailsElement.removeAttribute('open')
	summaryElement.setAttribute('aria-expanded', false)
	summaryElement.focus()
}

const trapFocusHandlers = {}

function trapFocus(container, elementToFocus = container) {
	var elements = getFocusableElements(container)
	var first = elements[0]
	var last = elements[elements.length - 1]

	removeTrapFocus()

	trapFocusHandlers.focusin = (event) => {
		if (event.target !== container && event.target !== last && event.target !== first) return

		document.addEventListener('keydown', trapFocusHandlers.keydown)
	}

	trapFocusHandlers.focusout = function () {
		document.removeEventListener('keydown', trapFocusHandlers.keydown)
	}

	trapFocusHandlers.keydown = function (event) {
		if (event.code.toUpperCase() !== 'TAB') return // If not TAB key
		// On the last focusable element and tab forward, focus the first element.
		if (event.target === last && !event.shiftKey) {
			event.preventDefault()
			first.focus()
		}

		//  On the first focusable element and tab backward, focus the last element.
		if ((event.target === container || event.target === first) && event.shiftKey) {
			event.preventDefault()
			last.focus()
		}
	}

	document.addEventListener('focusout', trapFocusHandlers.focusout)
	document.addEventListener('focusin', trapFocusHandlers.focusin)

	elementToFocus.focus()
}

function pauseAllMedia() {
	document.querySelectorAll('.js-youtube').forEach((video) => {
		video.contentWindow.postMessage(
			'{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
			'*',
		)
	})
	document.querySelectorAll('.js-vimeo').forEach((video) => {
		video.contentWindow.postMessage('{"method":"pause"}', '*')
	})
	document.querySelectorAll('video').forEach((video) => video.pause())
	document.querySelectorAll('product-model').forEach((model) => {
		if (model.modelViewerUI) model.modelViewerUI.pause()
	})
}

function removeTrapFocus(elementToFocus = null) {
	document.removeEventListener('focusin', trapFocusHandlers.focusin)
	document.removeEventListener('focusout', trapFocusHandlers.focusout)
	document.removeEventListener('keydown', trapFocusHandlers.keydown)

	if (elementToFocus && !elementToFocus.classList.contains('card-focused')) elementToFocus.focus()
}

class QuantityInput extends HTMLElement {
	constructor() {
		super()
		this.input = this.querySelector('input')
		this.changeEvent = new Event('change', { bubbles: true })

		this.querySelectorAll('button').forEach((button) => {
			this.setMinimumDisable()

			button.addEventListener('click', this.onButtonClick.bind(this))
		})

		var eventList = ['paste', 'input']

		for (event of eventList) {
			this.input.addEventListener(event, function (e) {
				const numberRegex = /^0*?[1-9]\d*$/

				if (numberRegex.test(e.currentTarget.value) || e.currentTarget.value === '') {
					e.currentTarget.value
				} else {
					e.currentTarget.value = 1
				}

				if (e.currentTarget.value === 1 || e.currentTarget.value === '') {
					this.previousElementSibling.classList.add('disabled')
				} else {
					this.previousElementSibling.classList.remove('disabled')
				}
			})
		}

		this.input.addEventListener('focusout', function (e) {
			if (e.currentTarget.value === '') {
				e.currentTarget.value = 1
			}
		})
	}

	setMinimumDisable() {
		if (this.input.value == 1) {
			this.querySelector('button[name="minus"]').classList.add('disabled')
		} else {
			this.querySelector('button[name="minus"]').classList.remove('disabled')
		}
	}

	onButtonClick(event) {
		event.preventDefault()
		const previousValue = this.input.value

		event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown()
		if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent)

		this.setMinimumDisable()
	}
}

customElements.define('quantity-input', QuantityInput)

function debounce(fn, wait) {
	let t
	return (...args) => {
		clearTimeout(t)
		t = setTimeout(() => fn.apply(this, args), wait)
	}
}

const serializeForm = (form) => {
	const obj = {}
	const formData = new FormData(form)
	for (const key of formData.keys()) {
		obj[key] = formData.get(key)
	}
	return JSON.stringify(obj)
}

function fetchConfig(type = 'json') {
	return {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Accept: `application/${type}`,
		},
	}
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
	window.Shopify = {}
}

Shopify.bind = function (fn, scope) {
	return function () {
		return fn.apply(scope, arguments)
	}
}

Shopify.setSelectorByValue = function (selector, value) {
	for (var i = 0, count = selector.options.length; i < count; i++) {
		var option = selector.options[i]
		if (value == option.value || value == option.innerHTML) {
			selector.selectedIndex = i
			return i
		}
	}
}

Shopify.addListener = function (target, eventName, callback) {
	target.addEventListener
		? target.addEventListener(eventName, callback, false)
		: target.attachEvent('on' + eventName, callback)
}

Shopify.postLink = function (path, options) {
	options = options || {}
	var method = options['method'] || 'post'
	var params = options['parameters'] || {}

	var form = document.createElement('form')
	form.setAttribute('method', method)
	form.setAttribute('action', path)

	for (var key in params) {
		var hiddenField = document.createElement('input')
		hiddenField.setAttribute('type', 'hidden')
		hiddenField.setAttribute('name', key)
		hiddenField.setAttribute('value', params[key])
		form.appendChild(hiddenField)
	}
	document.body.appendChild(form)
	form.submit()
	document.body.removeChild(form)
}

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
	this.countryEl = document.getElementById(country_domid)
	this.provinceEl = document.getElementById(province_domid)
	this.provinceContainer = document.getElementById(options['hideElement'] || province_domid)

	Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this))

	this.initCountry()
	this.initProvince()
}

Shopify.CountryProvinceSelector.prototype = {
	initCountry: function () {
		var value = this.countryEl.getAttribute('data-default')
		Shopify.setSelectorByValue(this.countryEl, value)
		this.countryHandler()
	},

	initProvince: function () {
		var value = this.provinceEl.getAttribute('data-default')
		if (value && this.provinceEl.options.length > 0) {
			Shopify.setSelectorByValue(this.provinceEl, value)
		}
	},

	countryHandler: function (e) {
		var opt = this.countryEl.options[this.countryEl.selectedIndex]
		var raw = opt.getAttribute('data-provinces')
		var provinces = JSON.parse(raw)

		this.clearOptions(this.provinceEl)
		if (provinces && provinces.length == 0) {
			this.provinceContainer.style.display = 'none'
		} else {
			for (var i = 0; i < provinces.length; i++) {
				var opt = document.createElement('option')
				opt.value = provinces[i][0]
				opt.innerHTML = provinces[i][1]
				this.provinceEl.appendChild(opt)
			}

			this.provinceContainer.style.display = ''
		}
	},

	clearOptions: function (selector) {
		while (selector.firstChild) {
			selector.removeChild(selector.firstChild)
		}
	},

	setOptions: function (selector, values) {
		for (var i = 0, count = values.length; i < values.length; i++) {
			var opt = document.createElement('option')
			opt.value = values[i]
			opt.innerHTML = values[i]
			selector.appendChild(opt)
		}
	},
}

class MenuDrawer extends HTMLElement {
	constructor() {
		super()

		this.mainDetailsToggle = this.querySelector('details')
		const summaryElements = this.querySelectorAll('summary')
		this.addAccessibilityAttributes(summaryElements)

		if (navigator.platform === 'iPhone')
			document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`)

		this.addEventListener('keyup', this.onKeyUp.bind(this))
		this.addEventListener('focusout', this.onFocusOut.bind(this))
		this.bindEvents()
	}

	bindEvents() {
		this.querySelectorAll('summary').forEach((summary) =>
			summary.addEventListener('click', this.onSummaryClick.bind(this)),
		)
		this.querySelectorAll('button').forEach((button) => {
			if (this.querySelector('.toggle-scheme-button') === button) return
			if (this.querySelector('.header__localization-button') === button) return
			if (this.querySelector('.header__localization-lang-button') === button) return
			button.addEventListener('click', this.onCloseButtonClick.bind(this))
		})
	}

	addAccessibilityAttributes(summaryElements) {
		summaryElements.forEach((element) => {
			element.setAttribute('role', 'button')
			element.setAttribute('aria-expanded', false)
			element.setAttribute('aria-controls', element.nextElementSibling.id)
		})
	}

	onKeyUp(event) {
		if (event.code.toUpperCase() !== 'ESCAPE') return

		const openDetailsElement = event.target.closest('details[open]')
		if (!openDetailsElement) return

		openDetailsElement === this.mainDetailsToggle
			? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary'))
			: this.closeSubmenu(openDetailsElement)
	}

	onSummaryClick(event) {
		const summaryElement = event.currentTarget
		const detailsElement = summaryElement.parentNode
		const isOpen = detailsElement.hasAttribute('open')

		if (detailsElement === this.mainDetailsToggle) {
			if (isOpen) event.preventDefault()
			isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement)
		} else {
			trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'))

			setTimeout(() => {
				detailsElement.classList.add('menu-opening')
			})
		}
	}

	openMenuDrawer(summaryElement) {
		setTimeout(() => {
			this.mainDetailsToggle.classList.add('menu-opening')
		})
		summaryElement.setAttribute('aria-expanded', true)
		trapFocus(this.mainDetailsToggle, summaryElement)
		document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
	}

	closeMenuDrawer(event, elementToFocus = false) {
		if (event !== undefined) {
			this.mainDetailsToggle.classList.remove('menu-opening')
			this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
				details.removeAttribute('open')
				details.classList.remove('menu-opening')
			})
			this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false)
			document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`)
			removeTrapFocus(elementToFocus)
			this.closeAnimation(this.mainDetailsToggle)
			this.header = this.header || document.querySelector('.shopify-section-header')
			const main = document.querySelector('main')
			if (
				main.querySelectorAll('.shopify-section')[0]?.classList.contains('section--has-overlay') &&
				!this.header.classList.contains('animate')
			) {
				this.header.classList.add('color-background-1', 'color-background-3')
			}
			if (
				this.header.classList.contains('color-background-1') &&
				!this.header.classList.contains('shopify-section-header-sticky')
			) {
				this.header.classList.add('color-background-3')
			}
		}
	}

	onFocusOut(event) {
		setTimeout(() => {
			if (
				this.mainDetailsToggle.hasAttribute('open') &&
				!this.mainDetailsToggle.contains(document.activeElement)
			)
				if (this.classList.contains('mobile-facets__wrapper')) this.closeMenuDrawer()
				else this.closeMenuDrawer(event)
		})
	}

	onCloseButtonClick(event) {
		const detailsElement = event.currentTarget.closest('details')
		this.closeSubmenu(detailsElement)
	}

	closeSubmenu(detailsElement) {
		detailsElement.classList.remove('menu-opening')
		removeTrapFocus()
		this.closeAnimation(detailsElement)
	}

	closeAnimation(detailsElement) {
		let animationStart

		const handleAnimation = (time) => {
			if (animationStart === undefined) {
				animationStart = time
			}

			const elapsedTime = time - animationStart

			if (elapsedTime < 400) {
				window.requestAnimationFrame(handleAnimation)
			} else {
				detailsElement.removeAttribute('open')
				if (detailsElement.closest('details[open]')) {
					trapFocus(
						detailsElement.closest('details[open]'),
						detailsElement.querySelector('summary'),
					)
				}
			}
		}

		window.requestAnimationFrame(handleAnimation)
	}
}

customElements.define('menu-drawer', MenuDrawer)

class HeaderDrawer extends MenuDrawer {
	constructor() {
		super()
	}

	openMenuDrawer(summaryElement) {
		this.header = this.header || document.querySelector('.shopify-section-header')
		this.borderOffset =
			this.borderOffset ||
			this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom')
				? 1
				: 0
		document.documentElement.style.setProperty(
			'--header-bottom-position',
			`${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`,
		)

		if (
			this.header.classList.contains('color-background-3') &&
			!this.header.classList.contains('shopify-section-header-sticky')
		) {
			this.header.classList.remove('color-background-3')
		}

		const main = document.querySelector('main')
		if (main.querySelectorAll('.shopify-section')[0]?.classList.contains('section--has-overlay')) {
			this.header.classList.remove('color-background-3')
		}

		setTimeout(() => {
			this.mainDetailsToggle.classList.add('menu-opening')
		})

		summaryElement.setAttribute('aria-expanded', true)
		trapFocus(this.mainDetailsToggle, summaryElement)
		document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
	}
}

customElements.define('header-drawer', HeaderDrawer)

class ModalDialog extends HTMLElement {
	constructor() {
		super()
		this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false))
		this.addEventListener('keyup', (event) => {
			if (event.code.toUpperCase() === 'ESCAPE') this.hide()
		})
		if (this.classList.contains('media-modal')) {
			this.addEventListener('pointerup', (event) => {
				if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model'))
					this.hide()
			})
		} else {
			this.addEventListener('click', (event) => {
				if (event.target === this) this.hide()
			})
		}
	}

	connectedCallback() {
		if (this.moved) return
		this.moved = true
		document.body.appendChild(this)
	}

	show(opener) {
		this.openedBy = opener
		const popup = this.querySelector('.template-popup')
		document.body.classList.add('overflow-hidden')
		this.setAttribute('open', '')
		if (popup) popup.loadContent()
		trapFocus(this, this.querySelector('[role="dialog"]'))
		window.pauseAllMedia()
	}

	hide() {
		let isOpen = false

		this.removeAttribute('open')
		removeTrapFocus(this.openedBy)
		window.pauseAllMedia()

		document.querySelectorAll('body > quick-add-modal').forEach((el) => {
			if (el.hasAttribute('open')) {
				isOpen = true
			}
		})

		if (!isOpen) {
			document.body.classList.remove('overflow-hidden')
			document.body.dispatchEvent(new CustomEvent('modalClosed'))
		}

		const images = document.querySelector('.product-media-modal__content')

		if (images) {
			images.classList.remove('zoom')
		}
	}
}

customElements.define('modal-dialog', ModalDialog)

class ModalOpener extends HTMLElement {
	constructor() {
		super()

		const button = this.querySelector('button')

		if (!button) return
		button.addEventListener('click', () => {
			const modal = document.querySelector(this.getAttribute('data-modal'))
			if (modal) modal.show(button)
		})
	}
}

customElements.define('modal-opener', ModalOpener)

class DeferredMedia extends HTMLElement {
	constructor() {
		super()
		this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener(
			'click',
			this.loadContent.bind(this),
		)
	}

	loadContent() {
		if (!this.getAttribute('loaded')) {
			const content = document.createElement('div')
			content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true))

			this.setAttribute('loaded', true)
			window.pauseAllMedia()
			this.appendChild(content.querySelector('video, model-viewer, iframe')).focus()

			if (
				this.closest('.swiper')?.swiper.slides[
					this.closest('.swiper').swiper.activeIndex
				].querySelector('model-viewer')
			) {
				if (
					!this.closest('.swiper')
						.swiper.slides[this.closest('.swiper').swiper.activeIndex].querySelector('model-viewer')
						.classList.contains('shopify-model-viewer-ui__disabled')
				) {
					this.closest('.swiper').swiper.params.noSwiping = true
					this.closest('.swiper').swiper.params.noSwipingClass = 'swiper-slide'
				}
			}
		}
	}
}

customElements.define('deferred-media', DeferredMedia)

class SuriFinishMedia {
	constructor(bank, sectionId) {
		this.bank = bank
		this.sectionId = sectionId
		this.groups = JSON.parse(bank.querySelector('script[type="application/json"]').textContent)
		this.gallery = document.querySelector(`[data-section="product-media-${sectionId}"]`)
		this.modal = document.getElementById(`ProductModal-${sectionId}`)
		this.images = new Map()
		this.nodes = new Map()
		this.revision = 0
	}

	static get(selector) {
		if (selector.dataset.variantMediaDisplay !== 'finish_color' || selector.closest('quick-add-modal, quick-view-modal')) return null
		const bank = document.getElementById(`SuriFinishMedia-${selector.dataset.section}`)
		if (!bank) return null
		if (!bank.finishController) {
			try { bank.finishController = new SuriFinishMedia(bank, selector.dataset.section) }
			catch { return null }
		}
		return bank.finishController
	}

	finishKey(color) {
		const value = (color || '').toLowerCase()
		if (value.includes('rose')) return 'rose'
		if (value.includes('silver') || value.includes('white gold')) return 'silver'
		return value.includes('gold') ? 'gold' : value
	}

	template(id) {
		return this.bank.querySelector(`template[data-finish-media-id="${id}"]`)
	}

	warmImage(id, thumbnail = false) {
		const key = thumbnail ? `thumbnail:${id}` : id
		if (this.images.has(key)) return this.images.get(key)
		const source = this.template(id)?.content.querySelector(thumbnail ? '.product__media-subitem img' : '.product__modal-opener img')
		if (!source) return null
		const image = new Image()
		for (const attribute of source.attributes) {
			if (!['src', 'srcset', 'sizes', 'loading', 'fetchpriority'].includes(attribute.name)) image.setAttribute(attribute.name, attribute.value)
		}
		image.loading = 'eager'
		image.fetchPriority = thumbnail ? 'low' : 'auto'
		const entry = { image, ready: false }
		image.sizes = source.sizes
		image.srcset = source.srcset
		image.src = source.src
		entry.promise = image.decode().then(() => { entry.ready = true }).catch(() => {})
		this.images.set(key, entry)
		return entry
	}

	warm(color) {
		const connection = navigator.connection
		if (connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '')) return
		const key = this.finishKey(color)
		if (this.bank.dataset.activeFinish === key) return
		const group = this.groups[key]
		if (group?.ids?.length) this.warmImage(group.primary || group.ids[0])
	}

	select(color) {
		const revision = ++this.revision
		const key = this.finishKey(color)
		const group = this.groups[key]
		if (!this.gallery || !Array.isArray(group?.ids) || !group.ids.every((id) => this.template(id))) {
			this.bank.dataset.activeFinish = ''
			return false
		}
		if (this.bank.dataset.activeFinish === key) return true
		if (!group.ids.length) {
			// No photos are mapped for this finish: keep the full gallery instead of showing nothing.
			this.bank.dataset.activeFinish = ''
			return false
		}
		const ids = [...group.ids]
		if (group.primary && ids.includes(group.primary)) {
			ids.splice(ids.indexOf(group.primary), 1)
			ids.unshift(group.primary)
		}
		const firstImage = this.warmImage(ids[0])
		if (firstImage) firstImage.image.fetchPriority = 'high'
		const apply = () => {
			if (revision !== this.revision || !this.bank.isConnected) return
			this.apply(ids)
			this.bank.dataset.activeFinish = key
		}
		if (firstImage?.ready) apply()
		else if (firstImage) firstImage.promise.then(apply)
		else return false
		return true
	}

	swap(container, selector, attribute, ids) {
		if (!container) return
		let cache = this.nodes.get(container)
		if (!cache) {
			cache = new Map(Array.from(container.querySelectorAll(selector), (node) => [node.getAttribute(attribute).replace(`${this.sectionId}-`, ''), node]))
			this.nodes.set(container, cache)
		}
		const slides = ids.map((id) => {
			if (!cache.has(id)) {
				const node = this.template(id).content.querySelector(selector).cloneNode(true)
				const zoom = node.querySelector('.js-image-zoom')
				if (zoom) zoom.addEventListener('click', () => this.modal.querySelector('.product-media-modal__content').classList.toggle('zoom'))
				const opener = node.querySelector('.product__media-toggle')
				if (opener) opener.addEventListener('click', () => {
					const slider = this.modal?.querySelector('.js-popup-slider')?.swiper
					const index = Array.from(container.querySelectorAll(selector)).indexOf(node)
					if (slider && index >= 0) slider.slideTo(index, 0)
				})
				cache.set(id, node)
			}
			const slide = cache.get(id)
			const thumbnail = slide.classList.contains('product__media-subitem')
			if (thumbnail) slide.style.transitionProperty = 'opacity'
			if (thumbnail || (id === ids[0] && container.matches('.js-media-list, .js-media-list-mobile'))) {
				const image = slide.querySelector(thumbnail ? 'img' : '.product__modal-opener img')
				const prepared = this.images.get(thumbnail ? `thumbnail:${id}` : id)
				if (image && prepared?.ready && image !== prepared.image) image.replaceWith(prepared.image)
				else if (image) image.loading = 'eager'
			}
			return slide
		})
		const wrapper = container.querySelector(':scope > .swiper-wrapper') || container
		wrapper.replaceChildren(...slides)
		container.dataset.currentIndex = '0'
		const slider = container.swiper
		if (slider) {
			slider.setTransition(0)
			slider.update()
			slider.slideTo(0, 0, false)
			slider.updateAutoHeight(0)
			slider.pagination?.render()
			slider.pagination?.update()
			slider.navigation?.update()
			if (slider.params?.autoHeight && slider.isHorizontal()) {
				const visibleSlides = slides.slice(0, Math.ceil(Number(slider.params.slidesPerView) || 1))
				const height = Math.max(...visibleSlides.map((slide) => slide.getBoundingClientRect().height))
				if (height > 0) wrapper.style.height = `${height}px`
			}
		}
	}

	showEmpty() {
		const message = this.bank.querySelector('template[data-finish-media-empty]')?.content.firstElementChild
		const list = this.gallery.querySelector('.product__media-list-wrapper')
		if (!message || !list) return false
		window.pauseAllMedia?.()
		this.gallery.querySelectorAll('.product__media-list-wrapper, .product__media-sublist').forEach((element) => {
			element.style.visibility = 'hidden'
			element.style.opacity = '0'
			element.style.pointerEvents = 'none'
			element.setAttribute('aria-hidden', 'true')
		})
		this.gallery.style.position = 'relative'
		this.gallery.querySelector('.suri-finish-media-empty')?.remove()
		this.gallery.append(message.cloneNode(true))
		return true
	}

	apply(ids) {
		window.pauseAllMedia?.()
		this.gallery.querySelector('.suri-finish-media-empty')?.remove()
		this.gallery.querySelectorAll('.product__media-list-wrapper, .product__media-sublist').forEach((element) => {
			element.style.visibility = ''
			element.style.opacity = ''
			element.style.pointerEvents = ''
			element.removeAttribute('aria-hidden')
		})
		this.swap(this.gallery.querySelector('.product__media-sublist'), '.product__media-subitem', 'data-media-sub-id', ids)
		this.swap(this.modal?.querySelector('.js-popup-slider'), '.product-media-modal__item', 'data-media-modal-id', ids)
		this.gallery.querySelectorAll('.product__media-list').forEach((container) => {
			this.swap(container, '.product__media-item', 'data-media-id', ids)
		})
		const slider = this.gallery.querySelector('.js-media-list, .js-media-list-mobile')?.swiper
		slider?.thumbs?.update(true)
		this.modal?.querySelector('.product-media-modal__content')?.classList.remove('zoom')
	}
}

class VariantSelects extends HTMLElement {
	constructor() {
		super()
		this.addEventListener('change', this.onVariantChange)
	}

	connectedCallback() {
		const prepare = () => {
			if (!this.isConnected || this.finishWarmScheduled) return
			const finish = SuriFinishMedia.get(this)
			if (!finish) return
			const index = Number(this.dataset.finishColorIndex || 0)
			const colorControl = this.tagName === 'VARIANT-RADIOS'
				? this.querySelectorAll('fieldset')[index]
				: this.querySelectorAll('select')[index]
			if (!colorControl) return
			this.finishWarmScheduled = true
			const warm = (event) => {
				const label = event.target.closest('label')
				const input = label?.control || event.target.closest('input, select')
				if (input && colorControl.contains(input) && !input.disabled) finish.warm(input.value)
			}
			colorControl.addEventListener('pointerover', warm, { passive: true })
			colorControl.addEventListener('focusin', warm)
			colorControl.addEventListener('touchstart', warm, { passive: true })
		}
		prepare()
		if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prepare, { once: true })
	}

	onVariantChange(event) {
		if (this.dataset.highVariant === 'true') {
			const selectedValues = this.tagName === 'VARIANT-RADIOS'
				? Array.from(this.querySelectorAll('fieldset'), (fieldset) => fieldset.querySelector('input:checked'))
				: Array.from(this.querySelectorAll('select'), (select) => select.selectedOptions[0])
			const optionValueIds = selectedValues.map((value) => value?.dataset.optionValueId)
			if (optionValueIds.length && optionValueIds.every(Boolean)) {
				const url = new URL(this.dataset.url, window.location.origin)
				url.searchParams.set('option_values', optionValueIds.join(','))
				window.location.assign(url.toString())
				return
			}
		}
		this.productInfoRequest?.abort()
		const isSizeChange = /size|length/i.test(event?.target?.name || '')
		this.updateOptions()
		this.updateMasterId()
		const finishColor = this.options[Number(this.dataset.finishColorIndex || 0)]
		this.localFinishMedia = SuriFinishMedia.get(this)?.select(finishColor) || false
		if (this.localFinishMedia) {
			const selectedColor = this.querySelector('input[name^="Color"]:checked')
			const colorName = this.querySelector('[data-color-name-id]')
			if (selectedColor && colorName) colorName.textContent = selectedColor.labels?.[0]?.title || selectedColor.value
		}
		const priceReady = this.hasCurrentPrice()
		if (!priceReady) this.toggleAddButton(true, '', false)
		this.updatePickupAvailability()
		this.updateVariantStatuses()

		if (!this.currentVariant) {
			this.toggleAddButton(true, '', true)
			this.setUnavailable()
			this.renderUnavailableColorMedia()
		} else {
			if (!this.localFinishMedia && !isSizeChange && !this.closest('floated-form') && this.currentVariant.featured_media) {
				this.updateMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`)
			}
			this.updateURL()
			this.updateVariantInput()
			// The form ID and unchanged server-rendered price are already correct.
			// Keep purchasing responsive while non-critical details refresh.
			if (priceReady) {
				document.getElementById(`price-${this.dataset.section}`)?.classList.remove('visibility-hidden')
				this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut)
			}
			if (this.canSkipProductInfo(priceReady, isSizeChange)) {
				const price = document.getElementById(`price-${this.dataset.section}`)
				if (price) price.dataset.variantId = String(this.currentVariant.id)
			} else {
				this.renderProductInfo()
			}
		}
		if (this.currentVariant) {
			document.dispatchEvent(
			  new CustomEvent("variant:change", {
				detail: {
				  variant: this.currentVariant,
				  previousVariant: this.previousVariant || null,
				  formElement: document.querySelector(
					`#${this.getAttribute('id')}`
				  ),
				  sectionId: this.dataset.section,
				},
			  })
			);
	  
			// Save the previous version
			this.previousVariant = this.currentVariant;
		  }
	}

	updateOptions() {
		// js-radio-colors was added to display Color swatches in the Dropdown type
		// but Color swatches are no longer supported in this type
		//const fieldsets = Array.from(this.querySelectorAll(".js-radio-colors"));

		this.options = Array.from(this.querySelectorAll('select'), (select) => select.value)
		//.concat(
		//	fieldsets.map((fieldset) => {
		//		return Array.from(fieldset.querySelectorAll("input")).find(
		//			(radio) => radio.checked,
		//		).value;
		//	}),
		//);
	}

	updateMasterId() {
		if (this.variantData || this.querySelector('[type="application/json"]')) {
			this.currentVariant = this.getVariantData().find((variant) => {
				//this.options.sort();
				//variant.options.sort();

				return !variant.options
					.map((option, index) => {
						return this.options[index] === option
					})
					.includes(false)
			})
		}
	}

	isHidden(elem) {
		const styles = window.getComputedStyle(elem)
		return styles.display === 'none' || styles.visibility === 'hidden'
	}

	updateMedia(mediaId) {
		if (!this.currentVariant || !this.currentVariant?.featured_media) return

		const currentSection = document.querySelector(`[data-section="main-${this.dataset.section}"]`)

		if (currentSection) {
			this.mediaList = currentSection.querySelector('.product__media-list')
			const activeMedia = this.mediaList.querySelector(`[data-media-id="${mediaId}"]`)
			if (!activeMedia) return
			this.mediaList.querySelectorAll('[data-media-id]').forEach((element) => {
				element.classList.remove('active')
			})
			if (activeMedia) activeMedia.classList.add('active')

			const mediaElements = Array.from(this.mediaList.querySelectorAll('.product__media-item'))
			const index = mediaElements.indexOf(activeMedia) || 0

			if (this.closest('.product__outer').querySelector('.product__media-list')) {
				this.closest('.product__outer').querySelector('.product__media-list').dataset.currentIndex =
					index
			}
		}

		const swiperWrappers = document.querySelectorAll('.product__media-wrapper')

		swiperWrappers.forEach((elem) => {
			if (!this.isHidden(elem)) {
				const newMedia = elem.querySelector(
					`[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`,
				)

				if (elem.querySelector('.js-media-list') && elem.querySelector('.js-media-list').swiper) {
					elem
						.querySelector('.js-media-list')
						.swiper.slideTo(elem.querySelector('.js-media-list').swiper.slides.indexOf(newMedia))
				} else if (
					elem.querySelector('.js-media-list-mobile') &&
					elem.querySelector('.js-media-list-mobile').swiper
				) {
					elem
						.querySelector('.js-media-list-mobile')
						.swiper.slideTo(
							elem.querySelector('.js-media-list-mobile').swiper.slides.indexOf(newMedia),
						)
				}
			}
		})
	}

	updateURL() {
		const detailsLink = this.closest('quick-add-modal')?.querySelector('.product__full-details')
		if (detailsLink && this.currentVariant) {
			const detailsUrl = new URL(detailsLink.href, window.location.origin)
			detailsUrl.searchParams.set('variant', this.currentVariant.id)
			detailsLink.href = detailsUrl.href
		}
		if (!this.classList.contains('featured-product-radios')) {
			if (!this.currentVariant || this.dataset.updateUrl === 'false') return
			window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`)
		}
	}

	updateVariantInput() {
		const productForms = document.querySelectorAll(
			`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
		)
		productForms.forEach((productForm) => {
			const input = productForm.querySelector('input[name="id"]')
			input.value = this.currentVariant.id
			input.dispatchEvent(new Event('change', { bubbles: true }))
		})
	}

	updateVariantStatuses() {
		const selectedOptionOneVariants = this.variantData.filter(
			(variant) => this.querySelector(':checked').value === variant.option1,
		)
		const inputWrappers = [...this.querySelectorAll('.product-form__controls')]
		inputWrappers.forEach((option, index) => {
			if (index === 0) return
			const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
			const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value
			const availableOptionInputsValue = selectedOptionOneVariants
				.filter(
					(variant) => variant.available && variant[`option${index}`] === previousOptionSelected,
				)
				.map((variantOption) => variantOption[`option${index + 1}`])
			this.setInputAvailability(optionInputs, availableOptionInputsValue)
		})
	}

	setInputAvailability(listOfOptions, listOfAvailableOptions) {
		listOfOptions.forEach((input) => {
			if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
				if (input.tagName === 'OPTION') {
					input.innerText = input.getAttribute('value')
				} else if (input.tagName === 'INPUT') {
					input.classList.remove('disabled')
				input.disabled = false
				input.setAttribute('aria-disabled', 'false')
				for (const label of input.labels || []) {
					const note = label.querySelector('[data-suri-unavailable-note]')
					if (note) note.hidden = true
				}
				}
			} else {
				if (input.tagName === 'OPTION') {
					input.innerText = window.variantStrings.unavailable_with_option.replace(
						'[value]',
						input.getAttribute('value'),
					)
				} else if (input.tagName === 'INPUT') {
					input.classList.add('disabled')
				input.disabled = true
				input.setAttribute('aria-disabled', 'true')
				for (const label of input.labels || []) {
					const note = label.querySelector('[data-suri-unavailable-note]')
					if (note) note.hidden = false
				}
				}
			}
		})
	}

	updatePickupAvailability() {
		const pickUpAvailability = document.querySelector('pickup-availability')
		if (!pickUpAvailability) return

		if (this.currentVariant && this.currentVariant.available) {
			pickUpAvailability.fetchAvailability(this.currentVariant.id)
		} else {
			pickUpAvailability.removeAttribute('available')
			pickUpAvailability.innerHTML = ''
		}
	}

	renderUnavailableColorMedia() {
		if (this.localFinishMedia || this.dataset.variantMediaDisplay !== 'finish_color') return

		const selectedColor = this.querySelector('input[name^="Color"]:checked')
		if (!selectedColor) return

		const mediaVariant = this.getVariantData().find(
			(variant) => variant.options[Number(this.dataset.finishColorIndex || 1)] === selectedColor.value,
		)
		if (!mediaVariant) return

		const requestedColor = selectedColor.value
		const sectionId = this.dataset.originalSection
			? this.dataset.originalSection
			: this.dataset.section

		fetch(`${this.dataset.url}?variant=${mediaVariant.id}&section_id=${sectionId}`)
			.then((response) => response.text())
			.then((responseText) => {
				const currentColor = this.querySelector('input[name^="Color"]:checked')
				if (this.currentVariant || currentColor?.value !== requestedColor) return

				const html = new DOMParser().parseFromString(responseText, 'text/html')
				this.replaceProductMedia(html)
			})
	}

	// The section refresh only updates price, SKU, inventory, colour name and gallery.
	// Skip the full-section download when none of those can change for this selection.
	canSkipProductInfo(priceReady, isSizeChange) {
		if (this.productInfoPending || !priceReady || this.closest('quick-add-modal, quick-view-modal, floated-form')) return false
		const sectionId = this.dataset.section
		if (document.getElementById(`Sku-${sectionId}`) || document.getElementById(`Inventory-${sectionId}`)) return false
		return Boolean(this.localFinishMedia || isSizeChange)
	}

	hasCurrentPrice() {
		const price = document.getElementById(`price-${this.dataset.section}`)
		const rendered = this.getVariantData().find(variant => String(variant.id) === price?.dataset.variantId)
		const selected = this.currentVariant
		return Boolean(rendered && selected && rendered.price === selected.price &&
			(rendered.compare_at_price || null) === (selected.compare_at_price || null) &&
			rendered.available === selected.available &&
			(rendered.unit_price || null) === (selected.unit_price || null) &&
			JSON.stringify(rendered.unit_price_measurement || null) === JSON.stringify(selected.unit_price_measurement || null))
	}

	renderProductInfo() {
		// Stays true until a refresh is applied, so an aborted refresh is never skipped later.
		this.productInfoPending = true
		const request = this.productInfoRequest = new AbortController()
		const requestedVariantId = this.currentVariant.id
		const sectionId = this.dataset.originalSection
			? this.dataset.originalSection
			: this.dataset.section

		fetch(
			`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
				this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
			}`,
			{ signal: request.signal },
		)
			.then((response) => {
				if (!response.ok) throw new Error('Product details could not be refreshed')
				return response.text()
			})
			.then((responseText) => {
				// prevent unnecessary ui changes from abandoned selections
				if (request.signal.aborted || this.currentVariant?.id !== requestedVariantId) return
				this.productInfoPending = false

				const html = new DOMParser().parseFromString(responseText, 'text/html')
				const destination = document.getElementById(
					`price-${this.dataset.section}`
				)
				const source = html.getElementById(
					`price-${
						this.dataset.originalSection
							? this.dataset.originalSection
							: this.dataset.section
					}`
				)
				const skuSource = html.getElementById(
					`Sku-${
						this.dataset.originalSection
							? this.dataset.originalSection
							: this.dataset.section
					}`
				)
				const skuDestination = document.getElementById(
					`Sku-${this.dataset.section}`
				)
				const inventorySource = html.getElementById(
					`Inventory-${
						this.dataset.originalSection
							? this.dataset.originalSection
							: this.dataset.section
					}`
				)
				const inventoryDestination = document.getElementById(
					`Inventory-${this.dataset.section}`
				)
				const colorNameSources = html.querySelectorAll(
					`[data-color-name-id="ColorName-${
						this.dataset.originalSection
							? this.dataset.originalSection
							: this.dataset.section
					}"]`
				)
				const colorNameDestinations = document.querySelectorAll(
					`[data-color-name-id="ColorName-${
						this.dataset.originalSection && !this.closest('quick-add-modal')
							? this.dataset.originalSection
							: this.dataset.section
					}"]`
				)
				if (colorNameSources?.length === colorNameDestinations?.length) {
					colorNameDestinations.forEach((colorNameDestination, index) => {
						colorNameDestination.innerHTML = colorNameSources[index].innerHTML
					})
				}

				if (source && destination) {
					destination.innerHTML = source.innerHTML
					destination.dataset.variantId = String(requestedVariantId)
				}
				if (inventorySource && inventoryDestination)
					inventoryDestination.innerHTML = inventorySource.innerHTML
				if (skuSource && skuDestination) {
					skuDestination.innerHTML = skuSource.innerHTML
					skuDestination.classList.toggle(
						'visibility-hidden',
						skuSource.classList.contains('visibility-hidden')
					)
				}

				const price = document.getElementById(`price-${this.dataset.section}`)

				if (price) price.classList.remove('visibility-hidden')

				if (inventoryDestination)
					inventoryDestination.classList.toggle(
						'visibility-hidden',
						inventorySource?.innerText === ''
					)

				this.toggleAddButton(
					!this.currentVariant.available,
					window.variantStrings.soldOut
				)

				// product media
				if (!this.localFinishMedia && this.dataset?.variantMediaDisplay !== 'show_all') {
					const sourceSectionId = this.dataset.originalSection
						? this.dataset.originalSection
						: this.dataset.section
					const currentSectionId = this.dataset.section

					const mediaSource = html.querySelector(
						`[data-section="product-media-${sourceSectionId}"]`
					)
					const mediaDestination = document.querySelector(
						`[data-section="product-media-${currentSectionId}"]`
					)

					// Preserve the gallery, its slide, and scroll position when only size changes.
					const mediaSignature = (container) => Array.from(
						container?.querySelectorAll('[data-media-id]') || [],
						(media) => media.dataset.mediaId.replace(`${sourceSectionId}-`, '').replace(`${currentSectionId}-`, ''),
					).join('|')
					const incomingMedia = mediaSignature(mediaSource)
					const mediaChanged = !incomingMedia || incomingMedia !== mediaSignature(mediaDestination)
					if (mediaSource && mediaDestination && mediaChanged) {
						mediaDestination.innerHTML = mediaSource.innerHTML

						if (this.dataset.variantMediaDisplay === 'finish_color') {
							const modalSource = html.getElementById(`ProductModal-${sourceSectionId}`)
							const modalDestination = document.getElementById(
								`ProductModal-${currentSectionId}`,
							)

							if (modalSource && modalDestination) {
								modalDestination.innerHTML = modalSource.innerHTML
							}
						}

						const parentQuickView = this.closest('quick-view-modal')
						if (parentQuickView) {
							if (typeof parentQuickView.removeDOMElements === 'function') {
								parentQuickView.removeDOMElements(mediaDestination)
							}
							if (typeof parentQuickView.initSlider === 'function') {
								parentQuickView.initSlider()
							}
						} else {
							const section = document.getElementById(
								`shopify-section-${currentSectionId}`
							)

							if (section && typeof initProductPage === 'function') {
								initProductPage(section)
							}
						}
						if (document.querySelector('.js-media-list')) {
							subSliderInit(true)
							sliderInit(true)
						}
						if (
							this.dataset.variantMediaDisplay === 'finish_color' &&
							document.querySelector('.js-popup-slider')
						) {
							popupSliderInit(true)
						}
					}
				}
			})
			.catch((error) => {
				if (error.name === 'AbortError' || this.currentVariant?.id !== requestedVariantId) return
				// A failed background refresh must not disable an unchanged, valid price.
				if (this.hasCurrentPrice()) this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut)
				else this.toggleAddButton(true, '', false)
				console.warn('Unable to refresh product details', error)
			})
	}

	replaceProductMedia(html) {
		if (this.dataset.variantMediaDisplay !== 'finish_color') return

		const sourceSectionId = this.dataset.originalSection
			? this.dataset.originalSection
			: this.dataset.section
		const currentSectionId = this.dataset.section

		const mediaSource = html.querySelector(
			`[data-section="product-media-${sourceSectionId}"]`,
		)
		const mediaDestination = document.querySelector(
			`[data-section="product-media-${currentSectionId}"]`,
		)

		if (!mediaSource || !mediaDestination) return

		mediaDestination.innerHTML = mediaSource.innerHTML

		if (this.dataset.variantMediaDisplay === 'finish_color') {
			const modalSource = html.getElementById(`ProductModal-${sourceSectionId}`)
			const modalDestination = document.getElementById(`ProductModal-${currentSectionId}`)

			if (modalSource && modalDestination) {
				modalDestination.innerHTML = modalSource.innerHTML
			}
		}

		const parentQuickView = this.closest('quick-view-modal')
		if (parentQuickView) {
			if (typeof parentQuickView.removeDOMElements === 'function') {
				parentQuickView.removeDOMElements(mediaDestination)
			}
			if (typeof parentQuickView.initSlider === 'function') {
				parentQuickView.initSlider()
			}
		} else {
			const section = document.getElementById(`shopify-section-${currentSectionId}`)

			if (section && typeof initProductPage === 'function') {
				initProductPage(section)
			}
		}
		if (document.querySelector('.js-media-list')) {
			subSliderInit(true)
			sliderInit(true)
		}
		if (
			this.dataset.variantMediaDisplay === 'finish_color' &&
			document.querySelector('.js-popup-slider')
		) {
			popupSliderInit(true)
		}
	}

	toggleAddButton(disable = true, text, modifyClass = true) {
		const productForm = document.getElementById(`product-form-${this.dataset.section}`)
		if (!productForm) return
		const addButton = productForm.querySelector('[name="add"]')
		const addButtonText = productForm.querySelector('[name="add"] > span')
		if (!addButton) return
		if (!addButton.dataset.suriAddLabel && !addButton.disabled) addButton.dataset.suriAddLabel = addButtonText.textContent.trim()

		if (disable) {
			addButton.setAttribute('disabled', 'disabled')
			if (text) addButtonText.textContent = text
		} else {
			addButton.removeAttribute('disabled')
			addButtonText.textContent = addButton.dataset.suriAddLabel || window.variantStrings.addToCart
		}

		if (!modifyClass) return
	}

	setUnavailable() {
		const button = document.getElementById(`product-form-${this.dataset.section}`)
		const addButton = button.querySelector('[name="add"]')
		const price = document.getElementById(`price-${this.dataset.section}`)
		const inventory = document.getElementById(`Inventory-${this.dataset.section}`)
		const sku = document.getElementById(`Sku-${this.dataset.section}`)

		if (!addButton) return
		this.toggleAddButton(true, window.variantStrings.unavailable)
		if (price) price.classList.add('visibility-hidden')
		if (inventory) inventory.classList.add('visibility-hidden')
		if (sku) sku.classList.add('visibility-hidden')
	}

	getVariantData() {
		this.variantData =
			this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent)
		return this.variantData
	}
}

customElements.define('variant-selects', VariantSelects)

class VariantRadios extends VariantSelects {
	constructor() {
		super()
	}

	connectedCallback() {
		super.connectedCallback()
		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', () => this.updateAikaDisplayLabels(), {
				once: true,
			})
		} else {
			this.updateAikaDisplayLabels()
		}
	}

	setInputAvailability(listOfOptions, listOfAvailableOptions) {
		listOfOptions.forEach((input) => {
			if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
				input.classList.remove('disabled')
				input.disabled = false
				input.setAttribute('aria-disabled', 'false')
				for (const label of input.labels || []) {
					const note = label.querySelector('[data-suri-unavailable-note]')
					if (note) note.hidden = true
				}
			} else {
				input.classList.add('disabled')
				input.disabled = true
				input.setAttribute('aria-disabled', 'true')
				for (const label of input.labels || []) {
					const note = label.querySelector('[data-suri-unavailable-note]')
					if (note) note.hidden = false
				}
			}
		})
	}

	updateOptions() {
		this.syncWhiteGoldSelection()
		const fieldsets = Array.from(this.querySelectorAll('fieldset'))
		this.options = fieldsets.map((fieldset) => {
			const select = fieldset.querySelector('select')
			if (select) return select.value
			return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value
		})
		this.updateAikaDisplayLabels()
	}

	getMaterialInputs() {
		const selector =
			this.dataset.whiteGoldVisibility === 'material'
				? 'input[name^="Jewelry Material"], input[name^="Jewelry material"]'
				: 'input[name^="Jewelry material"]'

		return Array.from(this.querySelectorAll(selector))
	}

	isSolidGoldMaterial(materialValue) {
		return ['10k gold', '14k gold', '18k gold'].includes(materialValue.toLowerCase())
	}

	usesWhiteGoldAlias() {
		if (this.dataset.whiteGoldVisibility !== 'material') return false

		const materialInputs = this.getMaterialInputs()
		const colorValues = Array.from(this.querySelectorAll('input[name^="Color"]')).map(
			(input) => input.value.toLowerCase(),
		)
		const hasSolidGoldMaterial = materialInputs.some((input) =>
			this.isSolidGoldMaterial(input.value),
		)

		return (
			hasSolidGoldMaterial &&
			colorValues.includes('silver') &&
			colorValues.includes('white gold')
		)
	}

	syncWhiteGoldSelection() {
		if (!this.usesWhiteGoldAlias()) return

		const materialInput = this.getMaterialInputs().find((input) => input.checked)
		const colorInputs = Array.from(this.querySelectorAll('input[name^="Color"]'))
		const selectedColor = colorInputs.find((input) => input.checked)
		if (!materialInput || !selectedColor) return

		const isBaseMaterial = !this.isSolidGoldMaterial(materialInput.value)
		const selectedColorValue = selectedColor.value.toLowerCase()
		const replacementColor = colorInputs.find((input) =>
			isBaseMaterial ? input.value === 'Silver' : input.value.toLowerCase() === 'white gold',
		)

		if (
			replacementColor &&
			((isBaseMaterial && selectedColorValue === 'white gold') ||
				(!isBaseMaterial && selectedColor.value === 'Silver'))
		) {
			replacementColor.checked = true
		}
	}

	updateAikaDisplayLabels() {
		const materialInput = this.getMaterialInputs().find((input) => input.checked)
		const colorInputs = Array.from(this.querySelectorAll('input[name^="Color"]'))
		if (!materialInput || colorInputs.length === 0) return

		const isBaseMaterial = !this.isSolidGoldMaterial(materialInput.value)
		const usesWhiteGoldAlias = this.usesWhiteGoldAlias()
		const finishLabels = this.querySelector('[data-suri-vermeil-finish]')?.dataset
		const colorLabels = isBaseMaterial
			? {
				Gold: finishLabels?.goldFinish || '18K Gold Vermeil',
				'Rose gold': finishLabels?.roseFinish || '18K Rose Gold Vermeil',
				'Rose Gold': finishLabels?.roseFinish || '18K Rose Gold Vermeil',
				'White gold': 'White Gold',
				'White Gold': 'White Gold',
				Silver: finishLabels?.silverFinish || 'Silver',
			}
			: {
				Gold: 'Yellow Gold',
				'Rose gold': 'Rose Gold',
				'Rose Gold': 'Rose Gold',
				'White gold': 'White Gold',
				'White Gold': 'White Gold',
				Silver: 'White Gold',
			}

		colorInputs.forEach((input) => {
			const label = this.querySelector(`label[for="${input.id}"]`)
			const displayLabel = input.dataset.suriDisplayValue || colorLabels[input.value] || input.value
			if (!label) return
			const hideWhiteGoldAlias =
				usesWhiteGoldAlias &&
				((isBaseMaterial && input.value.toLowerCase() === 'white gold') ||
					(!isBaseMaterial && input.value === 'Silver'))
			input.hidden = hideWhiteGoldAlias
			label.hidden = hideWhiteGoldAlias
			label.style.display = hideWhiteGoldAlias ? 'none' : ''
			label.title = displayLabel
			const hiddenLabel = label.querySelector('.visually-hidden')
			if (hiddenLabel) hiddenLabel.textContent = displayLabel
		})

		const selectedColor = colorInputs.find((input) => input.checked)
		const colorName = this.querySelector('[data-color-name-id]')
		if (selectedColor && colorName) {
			colorName.textContent = selectedColor.dataset.suriDisplayValue || colorLabels[selectedColor.value] || selectedColor.value
		}
	}
}

customElements.define('variant-radios', VariantRadios)

class PasswordViewer {
	constructor() {
		const passwordField = document.querySelectorAll('.field--pass')

		passwordField.forEach((el) => {
			const input = el.querySelector('input')
			const btnWrapper = el.querySelector('.button-pass-visibility')
			const btnOpen = el.querySelector('.icon-eye-close')
			const btnClose = el.querySelector('.icon-eye')

			input.addEventListener('input', () => {
				input.value !== ''
					? (btnWrapper.style.display = 'block')
					: (btnWrapper.style.display = 'none')
			})

			btnOpen.addEventListener('click', () => {
				input.type = 'text'
				btnOpen.style.display = 'none'
				btnClose.style.display = 'block'
			})

			btnClose.addEventListener('click', () => {
				input.type = 'password'
				btnOpen.style.display = 'block'
				btnClose.style.display = 'none'
			})
		})
	}
}

class ProductRecommendations extends HTMLElement {
	constructor() {
		super()

		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return
			observer.unobserve(this)

			fetch(this.dataset.url)
				.then((response) => response.text())
				.then((text) => {
					const html = document.createElement('div')
					html.innerHTML = text
					const recommendations = html.querySelector('product-recommendations')
					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML
					}

					/* Color swatches */
					const generateSrcset = (image, widths = []) => {
						const imageUrl = new URL(image['src'])
						return widths
							.filter((width) => width <= image['width'])
							.map((width) => {
								imageUrl.searchParams.set('width', width.toString())
								return `${imageUrl.href} ${width}w`
							})
							.join(', ')
					}

					const createImageElement = (image, classes, sizes, productTitle) => {
						const previewImage = image['preview_image']
						const newImage = new Image(previewImage['width'], previewImage['height'])
						newImage.className = classes
						newImage.alt = image['alt'] || productTitle
						newImage.sizes = sizes
						newImage.src = previewImage['src']
						newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066])
						newImage.loading = 'lazy'
						return newImage
					}

					const checkSwatches = () => {
						document.querySelectorAll('.js-color-swatches-wrapper').forEach((wrapper) => {
							if (wrapper.dataset.suriFinishCard) return
							wrapper.querySelectorAll('.js-color-swatches input').forEach((input) => {
								input.addEventListener('click', (event) => {
									const primaryImage = wrapper.querySelector('.media--first')
									const secondaryImage = wrapper.querySelector('.media--second')
									const handleProduct = wrapper.dataset.product

									if (event.currentTarget.checked && primaryImage) {
										wrapper
											.querySelector('.js-color-swatches-link')
											.setAttribute('href', event.currentTarget.dataset.variantLink)
										if (wrapper.querySelector('.card__add-to-cart button[name="add"]')) {
											wrapper
												.querySelector('.card__add-to-cart button[name="add"]')
												.setAttribute('aria-disabled', false)
											if (wrapper.querySelector('.card__add-to-cart button[name="add"] > span')) {
												wrapper
													.querySelector('.card__add-to-cart button[name="add"] > span')
													.classList.remove('hidden')
												wrapper
													.querySelector('.card__add-to-cart button[name="add"] .sold-out-message')
													.classList.add('hidden')
											}
											wrapper.querySelector('.card__add-to-cart input[name="id"]').value =
												event.currentTarget.dataset.variantId
										}
										const currentColor = event.currentTarget.value

										jQuery.getJSON(
											window.Shopify.routes.root + `products/${handleProduct}.js`,
											function (product) {
												const variant = product.variants.filter(
													(item) =>
														item.featured_media != null && item.options.includes(currentColor),
												)[0]

												if (variant) {
													const newPrimaryImage = createImageElement(
														variant['featured_media'],
														primaryImage.className,
														primaryImage.sizes,
														product.title,
													)

													if (newPrimaryImage.src !== primaryImage.src) {
														let flag = false
														if (secondaryImage) {
															const secondaryImagePathname = new URL(secondaryImage.src).pathname
															const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname

															if (secondaryImagePathname == newPrimaryImagePathname) {
																primaryImage.remove()
																secondaryImage.classList.remove('media--second')
																secondaryImage.classList.add('media--first')
																flag = true
															}
														}
														if (flag == false) {
															primaryImage.animate(
																{ opacity: [1, 0] },
																{
																	duration: 200,
																	easing: 'ease-in',
																	fill: 'forwards',
																},
															).finished
															setTimeout(function () {
																primaryImage.replaceWith(newPrimaryImage)
																newPrimaryImage.animate(
																	{ opacity: [0, 1] },
																	{ duration: 200, easing: 'ease-in' },
																)
																if (secondaryImage) {
																	secondaryImage.remove()
																}
															}, 200)
														}
													}
												}
											},
										)
									}
								})
							})
						})
					}

					checkSwatches()

					const calcTop = (section) => {
						const imageWrapper = section.querySelectorAll('.card__inner')
						let top = 0

						if (imageWrapper) {
							top = imageWrapper[0].offsetHeight / 2
						} else {
							top = 50
						}

						return top
					}

					const initSlider = () => {
						document.querySelectorAll('.js-recommendation-swiper').forEach((elem, index) => {
							let mobileLayout = 1
							if (elem.dataset.mobileLayout) {
								mobileLayout = elem.dataset.mobileLayout
							}
							let slider = new Swiper(elem, {
								cssMode: true, slidesPerView: mobileLayout,
								slidesPerGroup: 1,
								spaceBetween: 8,
								speed: 1000,
								navigation: {
									nextEl: elem.querySelector(
										'.product-recommendations__slider-nav .swiper-button-next',
									),
									prevEl: elem.querySelector(
										'.product-recommendations__slider-nav .swiper-button-prev',
									),
								},
								breakpoints: {
									576: {
										slidesPerView: 2,
										slidesPerGroup: 1,
									},
									750: {
										slidesPerView: 3,
										slidesPerGroup: 1,
									},
									1200: {
										slidesPerView: 4,
										slidesPerGroup: 1,
									},
								},
							})
						})
					}

					const initSection = () => {
						const section = this

						const sectionResizeObserver = new ResizeObserver((entries) => {
							const [entry] = entries
							let top = calcTop(section)
							if (section.querySelector('.product-recommendations__slider-nav'))
								section.querySelector('.product-recommendations__slider-nav').style.top = top + 'px'
						})

						sectionResizeObserver.observe(section)

						initSlider()
					}

					initSection()
				})
				.catch((e) => {
					console.error(e)
				})
		}

		new IntersectionObserver(handleIntersection.bind(this), {
			rootMargin: '0px 0px 200px 0px',
		}).observe(this)
	}
}

customElements.define('product-recommendations', ProductRecommendations)
;(function () {
	const initHeaderOverlay = () => {
		const main = document.getElementById('MainContent')
		const sections = main.querySelectorAll('.shopify-section')
		if (sections.length > 0) {
			const sectionFirstChild = sections[0].querySelector('.section--has-overlay')
			const headerGroupSections = document.querySelectorAll('.shopify-section-group-header-group')
			const header = document.querySelector('.shopify-section-header')

			if (sectionFirstChild) {
				if (sectionFirstChild.classList.contains('section--has-overlay')) {
					if (headerGroupSections[headerGroupSections.length - 1] === header) {
						sections[0].classList.remove('not-margin')
						header.classList.add('color-background-1', 'color-background-3')
					} else {
						sections[0].classList.add('not-margin')
						header.classList.remove('color-background-1', 'color-background-3')
					}
				} else {
					sections[0].classList.remove('not-margin')
					header.classList.remove('color-background-1', 'color-background-3')
				}
			}
		}
	}

	initHeaderOverlay()

	document.addEventListener('shopify:section:load', function () {
		initHeaderOverlay()
	})

	document.addEventListener('shopify:section:unload', function () {
		initHeaderOverlay()
	})

	document.addEventListener('shopify:section:reorder', function () {
		initHeaderOverlay()
	})
})()

function formatMoney(cents, format = '') {
	if (typeof cents === 'string') {
		cents = cents.replace('.', '')
	}
	cents = parseInt(cents, 10)

	let value = ''
	const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
	const formatString = format || theme.moneyFormat

	function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
		if (isNaN(number) || number == null) {
			return '0'
		}

		number = (number / 100.0).toFixed(precision)

		const parts = number.split('.')
		const dollarsAmount = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`)

		const centsAmount = precision > 0 ? decimal + parts[1] : ''

		return dollarsAmount + centsAmount
	}

	const match = formatString.match(placeholderRegex)
	const formatType = match ? match[1] : 'amount'

	switch (formatType) {
		case 'amount':
			value = formatWithDelimiters(cents, 2, ',', '.')
			break
		case 'amount_no_decimals':
			value = formatWithDelimiters(cents, 0, ',', '.')
			break
		case 'amount_with_comma_separator':
			value = formatWithDelimiters(cents, 2, '.', ',')
			break
		case 'amount_no_decimals_with_comma_separator':
			value = formatWithDelimiters(cents, 0, '.', ',')
			break
		case 'amount_with_apostrophe_separator':
			value = formatWithDelimiters(cents, 2, "'", '.')
			break
		case 'amount_no_decimals_with_space_separator':
			value = formatWithDelimiters(cents, 0, ' ', '.')
			break
		case 'amount_with_space_separator':
			value = formatWithDelimiters(cents, 2, ' ', ',')
			break
		case 'amount_with_period_and_space_separator':
			value = formatWithDelimiters(cents, 2, ' ', '.')
			break
		default:
			value = formatWithDelimiters(cents, 2, ',', '.')
	}

	return formatString.replace(placeholderRegex, value)
}

// CART REFRESH EVENT
// -----------------------------------------------------------------------------

document.documentElement.addEventListener("cart:refresh", () => {
	const sectionsToUpdate = [
	  { id: "cart-count-bubble", selector: "#cart-icon-bubble" },
	  { id: "cart-drawer", selector: "#CartDrawer" },
	  { id: "main-cart-items", selector: ".cart-items-wrapper" },
	  { id: "main-cart-footer", selector: ".cart__footer" },
	  { id: "main-cart-shipping", selector: ".cart-shipping" },
	];
  
	sectionsToUpdate.forEach((section) => {
	  fetch(`${routes.cart_url}?section_id=${section.id}`)
		.then((response) => response.text())
		.then((html) => {
		  const parsedHTML = new DOMParser().parseFromString(html, "text/html");
		  const sourceSection = parsedHTML.querySelector(section.selector);
		  const destinationSection = document.querySelector(section.selector);
		  if (sourceSection && destinationSection) {
			destinationSection.innerHTML = sourceSection.innerHTML;
		  }
		})
		.catch((e) => console.error(`Error updating ${section.id}:`, e));
	});
  });
  
  // CART REFRESH EVENT END
  // -----------------------------------------------------------------------------


